/** https://github.com/HiDeoo/intro.js-react/blob/main/src/helpers/server.js */
export function isServer() {
  return typeof window === 'undefined';
}
